import type { MenuDefinition } from '@/shared/layouts/menu/types';
import type { TenantMenuContext } from '../../../../types';
import { readStoredMenu } from '../../../services/menuStore';
import { filterMenuByPermissions } from './filterByPermissions';
import { hitowaMenu } from './hitowaMenu';

/**
 * The Hitowa sidebar.
 *
 * One tree for every account: entries carry the permissions that reveal them,
 * and the account's grants come from the login response (localStorage). Core
 * receives an already-filtered tree, so it never learns that Hitowa has
 * permissions at all.
 */
export function getHitowaClinicMenu(_context: TenantMenuContext): MenuDefinition {
  return readStoredMenu();
}

export { hitowaMenu, filterMenuByPermissions };
